namespace TabAurous {
    export interface AuthorizationRequest extends Serenity.ListRequest {
        Username?: string;
        Password?: string;
        EntityId?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        Remark?: string;
    }
}
